// extracted by mini-css-extract-plugin
export var boldText = "_2t-4";
export var checkboxContainer = "_2t-6";
export var closeIcon = "_2t-g";
export var container = "_2t-0";
export var drawer = "_2t-8";
export var drawerContent = "_2t-9";
export var extraSmallText = "_2t-5";
export var fulfillmentGroupTable = "_2t-e";
export var largeText = "_2t-3";
export var loadingSpinnerContainer = "_2t-h";
export var mediumText = "_2t-2";
export var narrow = "_2t-f";
export var notificationLink = "_2t-j";
export var packageCheckIconContainer = "_2t-7";
export var slideoutHeaderContainer = "_2t-a";
export var slideoutModal = "_2t-c";
export var stickyHeaderWrapper = "_2t-b";
export var table = "_2t-i";
export var tableContainer = "_2t-d";
export var tertiaryText = "_2t-1";